import attachEnterAsClick from 'utils/attachEnterAsClick';
import $ from 'jquery';

// icons
const createIcon = icon => `
    <svg class="svg-icon">
        <use xlink:href=#${icon} />
    </svg>
`;

// Init and setup all the events for the component
const initSearchBar = () => {
    // Define base elements and early return check
    const $searchTrigger = $('.js-search-bar-trigger');
    const $searchBar = $('.search-bar');
    const $searchOverlay = $searchBar.find('.search-overlay');
    if (!$searchTrigger.length || !$searchBar.length) { return; }

    // Setup the trigger to open
    $searchTrigger.click(e => {
        e.preventDefault();
        $searchBar.addClass('open');
        $searchOverlay.addClass('is-visible');
    });
    attachEnterAsClick($searchTrigger);

    // Setup the trigger to close off the search bar
    // ASSUMPTION: the search bar will ALWAYS come with a close trigger
    const $closeSearchTrigger = $searchBar.find('.js-search-bar-close');
    $closeSearchTrigger.click(() => {
        $searchBar.removeClass('open');
        $searchOverlay.removeClass('is-visible');
    });
    attachEnterAsClick($closeSearchTrigger);

    // Setup the enter press and search button click to trigger the search function
    // ASSUMPTION: the search bar will ALWAYS come with a search input and search button
    const $searchInput = $searchBar.find('input[type="text"]');
    const $searchButton = $searchBar.find('.js-search-bar-search');
    $searchInput.keypress(e => {
        if ((e.keyCode ? e.keyCode : e.which) === 13) { // Enter key
            e.preventDefault();

            if ($('.azure-search-form').length > 0) {
                $closeSearchTrigger.click();
            } else {
                window.location = $searchBar.data('search-url') + encodeURI($(e.target).val());
            }
        }
    });

    // Close the search on ESC key
    $searchInput.keydown(e => {
        if ((e.keyCode ? e.keyCode : e.which) === 27) { // Escape key
            $closeSearchTrigger.click();
        }
    });

    $searchButton.click(e => {
        e.preventDefault();

        if ($('.azure-search-form').length > 0) {
            $closeSearchTrigger.click();
        } else {
            window.location = $searchBar.data('search-url') + encodeURI($searchInput.val());
        }
    });
    attachEnterAsClick($searchButton);

    // Accessibility feature, if the user tab off the search bar, hide / close the search bar
    const closeSearchBarIfNotFocused = () => {
        setTimeout(() => {
            if (!$closeSearchTrigger.is(':focus') && !$searchInput.is(':focus') && !$searchButton.is(':focus')) {
                $closeSearchTrigger.click();
            }
        }, 500);
    };

    $closeSearchTrigger.blur(closeSearchBarIfNotFocused);
    $searchButton.blur(closeSearchBarIfNotFocused);
    $searchInput.blur(closeSearchBarIfNotFocused);
};

// update state
function azureUpdateFormState(el) {
    // mark current form
    window.azure_form = el.closest('.azure-search-form');
    $('.azure-search-form .search-input').val(window.azure_form.find('.search-input').val());
}

// handle redirect
function azureRedirectPage() {
    const { pathname } = window.location;
    const searchQuery = window.azure_form.find('.search-input').val();

    let redirect = window.azure_form.data('redirect');

    // ignore redirection if in search page
    if (pathname === redirect) {
        const searchParams = new URLSearchParams(window.location.search);

        // update query string if search term changes
        if (window.history.pushState && searchQuery !== searchParams.toString().replace('ask=', '')) {
            searchParams.set('ask', searchQuery);
            const newUrl = `
            ${window.location.protocol}//${window.location.host}${window.location.pathname}?${searchParams.toString()}
            `;
            window.history.pushState({ path: newUrl }, '', newUrl);
        }
        return false;
    }

    // redirect if not in search page and redirect url exist
    if (redirect !== undefined) {
        redirect += `?ask=${searchQuery}#s-azure-search-result`;
        window.location = redirect;
        return true;
    }

    return false;
}

// toggle loader
function azureToggleLoader(show) {
    if (show) {
        $('.loading').removeClass('hide');
    } else {
        $('.loading').addClass('hide');
    }
}

// loop feature items
function azureFeatureItem(item, data) {
    if (data.Feature === undefined || data.Feature.length === 0) return;

    const $featureList = item.find('.feature-list');
    const $tplFeature = $('#azure-search-tpl .feature-item');
    let featureItem;
    let i;

    for (i = 0; i < data.Feature.length; i += 1) {
        featureItem = $tplFeature.clone();
        featureItem.find('a').html(decodeURI(data.Feature[i].Name));
        featureItem.find('a').attr('href', data.Feature[i].FeatureUrl);
        featureItem.find('p').html(decodeURI(data.Feature[i].Summary.replace('%', '%25')));

        featureItem.appendTo($featureList);
    }
}

// loop item list
function azureAjaxRender({ data = {}, start = 0, perpage = 10 } = {}) {
    const $resultDiv = $('#azure-search-result');
    const $tpl = $('#azure-search-tpl .search-result-item');

    let item;
    let i;

    // reset result div
    $resultDiv.html('');

    // no result
    if (data.length === 0) {
        item = $tpl.clone();

        item.find('.title').remove();

        item.appendTo($resultDiv);
        return;
    }

    // debugger;

    // loop item
    for (i = (start * perpage); i < ((start * perpage) + perpage); i += 1) {
        if (!data[i]) break;

        item = $tpl.clone();
        item.find('.no-link-title').remove();
        item.find('.title a').html(decodeURI(data[i].Name));
        item.find('.title a').attr('href', data[i].UrlSlug);
        item.find('p').html(decodeURI(data[i].Summary.replace('%', '%25')));

        item.appendTo($resultDiv);

        // add feature item like google search result doest
        azureFeatureItem(item, data[i]);
    }
}

// show or hide simple navigation, add event on click
function azureRenderPagination({ start, perpage, data }) {
    const pagination = $('.c-pagination-simple');
    const maxPaging = pagination.data('max-paging');
    const li = [];
    const total = data['@odata.count'];
    let i;
    let page;
    let disabled;
    let selected;
    let tag;
    let newStart = 1;

    if (total <= perpage) return;

    // remove pagination
    pagination.find('ul li').remove();

    // include previous
    disabled = start === 1 ? ' disabled' : '';
    tag = disabled === '' ? 'a' : 'span';
    li.push(`
        <li class="previous${disabled}">
            <${tag} href="#prev">
                ${createIcon('chevron-left')}
            </${tag}>
        </li>
    `);

    // render pagination
    for (i = 1; i <= Math.ceil(total / perpage); i += 1) {
        selected = start === i ? ' selected' : '';
        tag = 'a';
        disabled = '';
        page = i;
        let renderLi = true;
        const threeFourth = Math.round((maxPaging / 4) * 3);
        const maxPage = start > maxPaging / 2 ? start + Math.round(maxPaging / 4) : threeFourth;
        const minPage = start - Math.floor(maxPaging / 4);
        const exclude = i === 2 && minPage === 3;

        // render left ...
        if (start > maxPaging / 2 && i > 1 && i < minPage && i <= total - threeFourth && !exclude) {
            tag = 'span';
            disabled = ' disabled';
            page = '...';

            if (i > 2) renderLi = false;
        }

        // render right ...
        if (i > maxPage && i < total && total - 1 !== maxPage + 1) {
            tag = 'span';
            disabled = ' disabled';
            page = '...';

            if (i < total - 1) renderLi = false;
        }

        if (renderLi) {
            li.push(`
                <li class="page${selected}${disabled}">
                    <${tag} href="#start-${page}">${page}</${tag}>
                </li>
            `);
        }
    }

    // include next
    disabled = start * perpage >= total ? ' disabled' : '';
    tag = disabled === '' ? 'a' : 'span';
    li.push(`
        <li class="next${disabled}">
            <${tag} href="#next">
                ${createIcon('chevron-right')}
            </${tag}>
        </li>
    `);

    // show pagination
    pagination.removeClass('hidden');
    pagination.find('ul').html(li.join(''));

    // make sure to remove the event
    $('.s-azure-search-result').off();

    // assign one click
    $('.s-azure-search-result').on('click', '.c-pagination-simple a', e => {
        e.preventDefault();

        let href = $(e.target).attr('href');
        href = href === undefined ? $($(e.target).closest('a')).attr('href') : href;

        if (href === '#next') {
            newStart = start + 1;
        } else if (href === '#prev') {
            newStart = start - 1;
        } else {
            newStart = href.replace('#start-', '') * 1;
        }

        azureAjaxRequest(newStart);
    });
}

// ajax request proccess
function azureAjaxRequest(start) {
    const apiUrl = window.azure_form.data('search-url');
    const perpage = window.azure_form.data('perpage') * 1;
    const keyword = window.azure_form.find('.search-input').val();

    // ignore if keyword empty
    if (keyword.trim() === '') {
        return;
    }

    // check for redirection
    if (azureRedirectPage()) {
        return;
    }

    // reset result state, hide pagination, show loader, show container
    azureToggleLoader(true);
    $('#azure-search-result .search-result-item').remove();
    $('.c-pagination-simple').addClass('hidden');
    $('#s-azure-search-result').css({ display: 'block' });

    $.ajax({ url: `${apiUrl}&$count=true&$top=${perpage}&$skip=${(start * perpage) - perpage}&search=${keyword}` })
        .done(data => {
            azureToggleLoader(false);

            // render result items
            azureAjaxRender({ data: data.value, perpage });

            // render pagination
            azureRenderPagination({ start, data, perpage });
        });
}

// automatically call ajax request if found GET query `ask`
function azureSearchQueryString() {
    const queryString = window.location.search;
    const queries = queryString.split('=');

    // make sure result div exist
    if ($('#azure-search-result').length === 0) {
        return;
    }

    if (queries.length === 2 && queries[0] === '?ask') {
        $('.azure-search-form .search-input').val(decodeURIComponent(queries[1]));
        azureAjaxRequest(1);
    }
}

// handle on press enter
function azureSubmitByEnter() {
    $('.azure-search-form .search-input').keypress(function (e) {
        if (e.which === 13) {
            // mark current form
            azureUpdateFormState($(this));

            // send request
            e.preventDefault();
            azureAjaxRequest(1);
        }
    });
}

// handle submit button
function azureSubmitForm() {
    $('.azure-search-form .search-button, .azure-search-form .icon-search').click(function (e) {
        // mark current form
        azureUpdateFormState($(this));

        // send request
        e.preventDefault();
        azureAjaxRequest(1);
    });
}

// Kick off the init on document ready
$(() => {
    initSearchBar();

    if ($('.azure-search-form').length !== 0) {
        window.azure_form = $('.azure-search-form');

        // do other new feature before init here., ie move result container to a better place

        // event on submit
        azureSubmitForm();

        // other new feature function here like search on hit enter
        azureSubmitByEnter();

        // do search if found GET query `ask` (azure search keyword)
        azureSearchQueryString();
    }
});



// WEBPACK FOOTER //
// ./src/components/search-bar/c-search-bar.js